import { Record } from 'immutable';
import { handleActions } from 'redux-actions';
import {
  ACCOUNT_PAGE_LOAD_REQUESTED,
  ACCOUNT_PAGE_LOAD_SUCCEEDED,
  ACCOUNT_PAGE_LOAD_FAILED,
} from '../actions';

const ReducerRecord = Record({
  error: false,
  fetching: false,
});

export default handleActions({
  [ACCOUNT_PAGE_LOAD_REQUESTED](state) {
    return state.set('fetching', true);
  },
  [ACCOUNT_PAGE_LOAD_SUCCEEDED](state) {
    return state
      .set('error', false)
      .set('fetching', false);
  },
  [ACCOUNT_PAGE_LOAD_FAILED](state) {
    return state
      .set('error', true)
      .set('fetching', false);
  },
}, new ReducerRecord());
